import { createSelector } from 'reselect'

import { isAvailableFeatureSelector } from 'features/billing'
import { isAdminOrOwnerSelector, isGroupAdminSelector } from 'selectors/current_user'

const reportingSliceSelector = ({ reporting }) => reporting

export const paramsSliceSelector = createSelector(
  reportingSliceSelector,
  ({ params }) => params
)

export const selectedFiltersSelector = createSelector(
  paramsSliceSelector,
  ({ users, teams, groups, eventTypes }) => [users, teams, groups, eventTypes].find((items) => items && items.length > 0) || []
)

export const filtersSelector = createSelector(
  paramsSliceSelector,
  ({ users, teams, groups, eventTypes }) => ({
    users: users || [],
    teams: teams || [],
    groups: groups || [],
    eventTypes: eventTypes || []
  })
)

export const selectedFilterUuidsSelector = createSelector(
  selectedFiltersSelector,
  (items) => items.map(({ uuid }) => uuid)
)

export const isReportingDashboardFeatureEnabledSelector = (state) => isAvailableFeatureSelector(
  state, { featureKey: 'reporting_dashboard' }
)

export const ownerOrAdminCanViewReportingSelector = createSelector(
  isAdminOrOwnerSelector, (isAdminOrOwner) => isAdminOrOwner
)

export const isPrivilegedSelector = createSelector(
  isGroupAdminSelector,
  isAdminOrOwnerSelector,
  (isGroupAdmin, isAdminOrOwner) => (
    isGroupAdmin || isAdminOrOwner
  )
)

export const userGroupAdminCanViewReportingSelector = createSelector(
  isGroupAdminSelector, (isGroupAdmin) => isGroupAdmin
)

export const getPastDateParamsSelector = createSelector(
  paramsSliceSelector,
  ({ past: { start, end } }) => ({ start, end })
)

export const getFutureDateParamsSelector = createSelector(
  paramsSliceSelector,
  ({ future: { start, end } }) => ({ start, end })
)

export const getFilterParamsSelector = createSelector(
  paramsSliceSelector,
  ({ users, teams, groups, eventTypes }) => ({ users, teams, groups, eventTypes })
)
